module.exports = __webpack_public_path__ + "static/media/google.247d8949.jpg";